import male1 from "../assets/images/user-avtar/male-1.jpg";
import male2 from "../assets/images/user-avtar/male-2.jpg";
import male3 from "../assets/images/user-avtar/male-3.jpg";
import male4 from "../assets/images/user-avtar/male-4.jpg";
import male5 from "../assets/images/user-avtar/male-5.jpg";
import male6 from "../assets/images/user-avtar/male-6.jpg";
import female1 from "../assets/images/user-avtar/female-1.jpg";
import female2 from "../assets/images/user-avtar/female-2.jpg";
import female3 from "../assets/images/user-avtar/female-3.jpg";
import female4 from "../assets/images/user-avtar/female-4.jpg";
import female5 from "../assets/images/user-avtar/female-5.jpg";
import female6 from "../assets/images/user-avtar/female-6.jpg";

export const userMaleAvtars = [male1, male2, male3, male4, male5, male6];

export const userFemaleAvtars = [
  female1,
  female2,
  female3,
  female4,
  female5,
  female6,
];

export function generateRandomNumberFromId(id) {
  const hash = id
    ?.split("")
    ?.reduce((acc, char) => acc + char?.charCodeAt(0), 0);

  const randomNumber = hash % 6;

  return randomNumber;
}

export const getUserIcon = (gender, id) => {
  const index = generateRandomNumberFromId(id);
  if (gender === "Male") {
    return userMaleAvtars[index];
  } else if (gender === "Female") {
    return userFemaleAvtars[index];
  } else {
    return userMaleAvtars[index];
  }
};
